// 导入路由模块
import { createRouter, createWebHistory } from "vue-router";
import { getToken, getUserName } from "@/utils/auth";

// 定义路由规则
const Home = () => import("./../views/home.vue");
const About = () => import("./../views/about.vue");
const Layout = () => import("./../components/Layout.vue");

const routes = [
  {
    path: "/",
    redirect: (to) => {
      // 根据登录状态决定根路径跳转目标
      const token = getToken();
      return token ? "/task/publish" : "/login";
    },
  },
  {
    path: "/login",
    component: () => import("@/views/login.vue"),
  },
  {
    path: "/",
    component: Layout,
    redirect: "/task/publish",
    children: [
      {
        path: "task/publish",
        name: "TaskPublish",
        component: () => import("@/views/task/publish.vue"),
      },
      {
        path: "video/publish",
        name: "VideoPublish",
        component: () => import("@/views/video/publish.vue"),
      },
    ],
  },
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/about",
    component: About,
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.path !== "/login" && !token) {
    next("/login");
  } else if (to.path === "/login" && token) {
    next("/task/publish");
  } else {
    next();
  }
});

// 动态设置页面标题：登录页显示“欢迎登录”，登录后显示接口返回的 name
router.afterEach((to) => {
  if (to.path === "/login") {
    document.title = "欢迎登录";
  } else {
    document.title = getUserName() || "欢迎登录";
  }
});

export default router;
